<template>
	<div>
		<template v-if="payroll_payment_report == true && designations != null && departments != null && branches != null && cities != null">
			<div class="page-top mb-1 mb-3 clearfix">
				<h1 class="float-left"> Payroll Payment Report </h1>
			</div>
			<div class="peopple-managment-main">
				<div class="people-management-inner-content pt-5 pb-0 pl-5 pr-5">
					<div class="row">
						<div class="col-md-3">
							<div class="form-group">
								<label class="label block-label"> Designation </label>
								<select v-model="designation_id" name="designation_id" class="selectpicker custom-select2" v-if="designations != null">
									<option value="" selected>Select Designation</option>
									<option v-for="designation in designations" v-bind:value="designation.id" v-bind:key="designation.id">
										{{ designation.name }}
									</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label class="label block-label"> City </label>
								<select v-model="city_id" name="city_id" class="selectpicker custom-select2" v-if="cities != null">
									<option value="" selected>Select City</option>
									<option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id">
										{{ city.name }}
									</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label class="label block-label"> Branch </label>
								<select v-model="branch_id" name="branch_id" class="selectpicker custom-select2" v-if="branches != null">
									<option value="" selected>Select Branch</option>
									<option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">
										{{ branch.name }}
									</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label class="label block-label"> Department </label>
								<select v-model="department_id" name="department_id" class="selectpicker custom-select2" v-if="departments != null">
									<option value="" selected>Select Department</option>
									<option v-for="department in departments" v-bind:value="department.id" v-bind:key="department.id">
										{{ department.name }}
									</option>
								</select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label class="label block-label"> Employee Name </label>
								<input name="employee_name" class="form-control" v-model="employee_name" placeholder="Enter employee name">
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label class="label block-label"> Employee Number </label>
								<input name="employee_number" class="form-control" v-model="employee_number" placeholder="Enter employee phone number">
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label class="label block-label"> Account Number </label>
								<input name="account_number" class="form-control" v-model="account_number" placeholder="Enter account number or Cnic">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label class="label block-label"> Amount of Transfer </label>
								<input name="amount_of_transfer" class="form-control" v-model="amount_of_transfer" placeholder="Enter Transfer Amount">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label class="label block-label"> Mode of Payment </label>
								<select v-model="account_type" name="account_type" class="selectpicker custom-select2">
									<option value="" selected>Select Account Type</option>
									<option value="SIMSIM" v-if="$global.user_company_payment_engine == 'FINCA'">SIMSIM</option>
									<option value="EASY_PAISA_WALLET" v-if="$global.user_company_payment_engine == 'EASY_PAISA'">Easypaisa Wallet</option>
									<option value="EASY_PAISA_CNIC" v-if="$global.user_company_payment_engine == 'EASY_PAISA'">Easypaisa CNIC</option>
									<option value="IBFT">IBFT</option>
								</select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-3">
							<div class="form-group">
								<label class="label block-label"> Transaction ID </label>
								<input name="transaction_id" class="form-control" v-model="transaction_id" placeholder="Enter Transaction ID">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label class="label block-label"> Batch ID </label>
								<input name="batch_id" class="form-control" v-model="batch_id" placeholder="Enter Batch ID">
							</div>
						</div>


						<div class="col-md-3">
							<div class="form-group">
								<label class="label block-label"> From Date </label>
								<datepicker name="from_date" v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label class="label block-label"> To Date </label>
								<datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-3">
							<div class="form-group">
								<label class="label block-label"> Token ID </label>
								<input name="ep_cnic_token" class="form-control" v-model="ep_cnic_token" placeholder="Enter EasyPaisa Token ID">
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group align-right">
								<br>
								<button @click="getEmployeeBatchReport" v-if="!showBtn" class="btn btn-primary">Search</button>
								<button @click="filterTable" v-if="showBtn" class="btn btn-primary">Search</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tab-content" id="myTabContent">
				<div v-show="!hasPer" class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
					<div class="empty-main pt-0" style="height: 100px">
						<div class="empty-inner">
							<img src="/images/new_empty_payments.png" alt="" />
							<h2> Hi, {{user}}! </h2>
							<p> Select your requirements and export your desired report </p>
						</div>
					</div>
				</div>
				<div v-show="hasPer">
					<div class="mt-3 mb-3 tbl-fiters-search-area  hidden-xs" v-if="export_payroll_payment_report === true">
						<div class="field-box export-attendance">
							<button class="btn btn-primary export" @click="exportReport">Export Report</button>
						</div>
					</div>

					<div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
						<table id="employeePaymentReportTable" class="table" style="width:100%">
							<thead>
								<tr>
									<th style="display: none">ID</th>
									<th>Name</th>
									<th>Salary</th>
									<th>Additional Earnings</th>
									<th>Reimbursements</th>
									<th>Deductions</th>
									<th>Net Payable</th>
									<th>Transaction ID</th>
									<th>Account Number</th>
									<th>Mobile Number</th>
									<th>Mode of Payment</th>
									<th>Batch ID</th>
									<th>Token ID</th>
									<th>Date</th>
								</tr>
							</thead>
						</table>
					</div>
				</div>
			</div>
		</template>
		<template v-else-if="payroll_payment_report === null">
			<preLoader></preLoader>
		</template>
		<template v-else-if="payroll_payment_report === false">
			<notAllowed></notAllowed>
		</template>
	</div>
</template>

<script>
	var gThat = null;
	export default {
		data() {
			return {
				designation_id : '',
				city_id : '',
				branch_id : '',
				department_id : '',
				employee_name : '',
				employee_number : '',
				account_number : '',
				amount_of_transfer : '',
				account_type : '',
				transaction_id : '',
				batch_id : '',
				from_date : new Date(),
				to_date : new Date(),
				ep_cnic_token : '',
				// filter data
				designations : null,
				cities : null,
				branches: null,
				departments: null,
				user: '',
				hasPer: false,
				showBtn: false,
				payroll_payment_report: null,
				export_payroll_payment_report: null,
				dtTable: null,
			};
		},
		mounted() {
			gThat = this;
			this.$Progress.start();
			this.can('payroll_payment_report|export_payroll_payment_report').then(result => {
				this.payroll_payment_report = result.payroll_payment_report;
				this.export_payroll_payment_report = result.export_payroll_payment_report;
				this.user = result.user_name;
			}).then(result => {
				if(this.payroll_payment_report == true){
					this.loadFiltersData();
					this.$Progress.finish();
				}else{
					this.$Progress.finish();
				}
			});
		},
		methods: {
			loadFiltersData: function(){
				this.$Progress.start();
				axios.get('/api/employee_batch_payment_report_data')
				.then(res => {
					if(res.status == 200){
						this.designations = res.data.designations;
						this.cities = res.data.cities;
						this.branches = res.data.branches;
						this.departments = res.data.departments;
						this.$Progress.finish();
					}else{
						this.$Progress.fail();
						this.showAlertBox('error','Error to load data');
					}
				})
				.then(res=>{
					$(this.$el).find('.selectpicker').selectpicker('refresh');
				})
				.catch(err => {
					this.$Progress.fail();
					this.showAlertBox('error','Error to load data');
				});
			},
			filterTable(){
				this.dtTable.ajax.reload(function()
				{
					gThat.dtTable.draw();

				}, false);
			},
			exportReport: function(){
				this.$Progress.start();
				var formData = {
					'to_date': moment(this.to_date).format('YYYY-MM-DD'),
					'from_date': moment(this.from_date).format('YYYY-MM-DD'),
					'designation': this.designation_id,
					'city': this.city_id,
					'branch': this.branch_id,
					'department': this.department_id,
					'account_type': this.account_type,
					'transaction_id': this.transaction_id,
					'account_number': this.account_number,
					'employee_name': this.employee_name,
					'employee_number': this.employee_number,
					'amount_of_transfer': this.amount_of_transfer,
					'batch_id': this.batch_id,
					'ep_cnic_token': this.ep_cnic_token,
				}
				axios.post('/api/employee_batch_payment_export', formData,{
					responseType: 'blob'
				})
				.then(res => {
					if(res.status == 200){
						const url = URL.createObjectURL(new Blob([res.data], {
							type: 'application/vnd.ms-excel'
						}))

						const link = document.createElement('a')
						link.href = url
						link.setAttribute('download', 'employeePaymentReport.xlsx')
						document.body.appendChild(link)
						link.click()
						this.$Progress.finish();
					}else{
						this.$Progress.fail();
						this.showAlertBox('error','Error to load data');
					}
				})
				.catch(err => {
					this.$Progress.fail();
					this.showAlertBox('error','Error to load data');
				});
			},
			getEmployeeBatchReport: function(){
				this.$Progress.start();
				var that = this;
				this.dtTable = $('#employeePaymentReportTable').DataTable({
					sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
					processing: true,
					serverSide: true,
					ajax: {
						"url": "api/employee_batch_payment_report",
						"data": function (d) {
							d.designation = that.designation_id;
							d.department = that.department_id;
							d.city = that.city_id;
							d.branch = that.branch_id;
							d.employee_name = that.employee_name;
							d.employee_number = that.employee_number;
							d.account_number = that.account_number;
							d.transaction_id = that.transaction_id;
							d.account_type = that.account_type;
							d.amount_of_transfer = that.amount_of_transfer;
							d.batch_id = that.batch_id;
							d.from_date = moment(that.from_date).format('YYYY-MM-DD');
							d.to_date = moment(that.to_date).format('YYYY-MM-DD');
							d.ep_cnic_token = that.ep_cnic_token;
						},
						"headers": window.axios.defaults.headers.common,
						"dataSrc": "records",
					},
					deferRender: true,
					columns: [
					{data: 'id', visible: false},
					{render: function(data,type,full){
						if(full.user != null){
							return full.user.name;
						}else{
							return "---";
						}
					}},
					{render: function(data,type,full){
						var obj = JSON.parse(full.breakUp);
						var basic_salary, housing_allowance, medical_allowance, car_allowance, fuel_allowance, other_allowance;
						if(obj.basic_salary) {
							basic_salary = obj.basic_salary;
						} else {
							basic_salary = 0;
						}
						if(obj.housing_allowance) {
							housing_allowance = obj.housing_allowance;
						} else {
							housing_allowance = 0;
						}
						if(obj.medical_allowance) {
							medical_allowance = obj.medical_allowance;
						} else {
							medical_allowance = 0;
						}
						if(obj.car_allowance) {
							car_allowance = obj.car_allowance;
						} else {
							car_allowance = 0;
						}
						if(obj.fuel_allowance) {
							fuel_allowance = obj.fuel_allowance;
						} else {
							fuel_allowance = 0;
						}
						if(obj.other_allowance) {
							other_allowance = obj.other_allowance;
						} else {
							other_allowance = 0;
						}
						var total_salary = parseInt(basic_salary) + parseInt(housing_allowance) + parseInt(medical_allowance) + parseInt(car_allowance) + parseInt(fuel_allowance) + parseInt(other_allowance);
						var total_salary = new Intl.NumberFormat().format(total_salary);
						if(total_salary == 0){
							return '---';
						}else{
							return total_salary;
						}
					}},
					{render: function(data,type,full){
						var obj = JSON.parse(full.breakUp);
						var overtime, bonus, commission, other_additional_earning;
						if(obj.overtime) {
							overtime = obj.overtime;
						} else {
							overtime = 0;
						}
						if(obj.bonus) {
							bonus = obj.bonus;
						} else {
							bonus = 0;
						}
						if(obj.commission) {
							commission = obj.commission;
						} else {
							commission = 0;
						}
						if(obj.other_additional_earning) {
							other_additional_earning = obj.other_additional_earning;
						} else {
							other_additional_earning = 0;
						}
						var total_additional_earning = parseInt(overtime) + parseInt(bonus) + parseInt(commission) + parseInt(other_additional_earning);
						var total_additional_earning = new Intl.NumberFormat().format(total_additional_earning);
						if(total_additional_earning == 0){
							return '---';
						}else{
							return total_additional_earning;
						}
					}},
					{render: function(data,type,full){
						var obj = JSON.parse(full.breakUp);
						var fuelreimbursement, travelingreimbursement, reimbursements;
						if(obj.fuelreimbursement) {
							fuelreimbursement = obj.fuelreimbursement;
						} else {
							fuelreimbursement = 0;
						}
						if(obj.travelingreimbursement) {
							travelingreimbursement = obj.travelingreimbursement;
						} else {
							travelingreimbursement = 0;
						}
						if(obj.reimbursements) {
							reimbursements = obj.reimbursements;
						} else {
							reimbursements = 0;
						}
						var totalreimbursement = parseInt(fuelreimbursement) + parseInt(travelingreimbursement) + parseInt(reimbursements);
						var totalreimbursement = new Intl.NumberFormat().format(totalreimbursement);
						if(totalreimbursement == 0){
							return '---';
						}else{
							return totalreimbursement;
						}
					}},
					{render: function(data,type,full){
						var obj = JSON.parse(full.breakUp);
						var income_tax, eobi, provident_fund, other_deduction, outstanding_advance_salary, fees_advance_salary;
						if(obj.income_tax) {
							income_tax = obj.income_tax;
						} else {
							income_tax = 0;
						}
						if(obj.eobi) {
							eobi = obj.eobi;
						} else {
							eobi = 0;
						}
						if(obj.provident_fund) {
							provident_fund = obj.provident_fund;
						} else {
							provident_fund = 0;
						}
						if(obj.other_deduction) {
							other_deduction = obj.other_deduction;
						} else {
							other_deduction = 0;
						}
						if(obj.outstanding_advance_salary) {
							outstanding_advance_salary = obj.outstanding_advance_salary;
						} else {
							outstanding_advance_salary = 0;
						}
						if(obj.fees_advance_salary) {
							fees_advance_salary = obj.fees_advance_salary;
						} else {
							fees_advance_salary = 0;
						}
						var deduction = parseInt(income_tax) + parseInt(eobi) + parseInt(provident_fund) + parseInt(other_deduction) + parseInt(outstanding_advance_salary) + parseInt(fees_advance_salary);
						var deduction = new Intl.NumberFormat().format(deduction);
						if(deduction == 0){
							return '---';
						}else{
							return deduction;
						}
					}},
					{render: function(data,type,full){
						var net_salary = new Intl.NumberFormat().format(full.net_salary);
						if(net_salary != null){
							return net_salary;
						}
					}},
					{render: function(data,type,full){
						var transaction_id =  full.transactionId;
						if(transaction_id != null){
							return transaction_id;
						}
					}},
					{render: function(data,type,full){
						var account_number =  full.account_number;
						if(account_number != null){
							return account_number;
						}else{
							return '---';
						}
					}},
					{render: function(data,type,full){
						var mobileNo =  full.mobileNo;
						if(mobileNo != null){
							return mobileNo;
						}else{
							return '---';
						}
					}},
					{render: function(data,type,full){
						var account_type =  full.account_type;
						if(account_type != null){
							return account_type;
						}
					}},
					{render: function(data,type,full){
						var batch_id =  full.payrollId;
						if(batch_id != null){
							return batch_id;
						}
					}},
					{render: function(data,type,full){
						return (full.transactionToken != null ? full.transactionToken : '---');
					}},
					{render: function(data,type,full){
						var date = full['created_at'];
						return ''+moment(date).format('MMM D, Y')+'';
					}},
					],
					"order": [[ 0, "desc" ]],
					"initComplete": () => {
						that.hasPer = true;
						that.showBtn = true;
						this.$Progress.finish();
					}
				});
}
},
created() {
			//
		}
	}
</script>
